'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$() {
  this.aDI = null;
  this.aDJ = false;
  this.aDK = null;
  this.aDL = false;
}
export { $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ as $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ };
$p = $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$;
/** @constructor */
function $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$() {
}
export { $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ as $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ };
$h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$.prototype = $p;
$p.aA = (function() {
  if ((!this.aDJ)) {
    this.aDI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeUri$$anon$2(this);
    this.aDJ = true;
  }
  return this.aDI;
});
$p.bNO = (function() {
  if ((!this.aDL)) {
    this.aDK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeUri$$anon$3(this);
    this.aDL = true;
  }
  return this.aDK;
});
var $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$, "app.data.OrganizationWebsiteUri$package$OrganizationWebsiteUri$", ({
  Eu: 1,
  B: 1,
  C: 1,
  oK: 1
}));
export { $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ as $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ };
var $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$;
function $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$() {
  if ((!$n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$)) {
    $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ = new $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$();
  }
  return $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$;
}
export { $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ as $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$ };
//# sourceMappingURL=app.data.-Organization-Website-Uri$package$-Organization-Website-Uri$.js.map
